module.exports = "<template ngbModalContainer></template>\n<toaster-container></toaster-container>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1002
// module chunks = 1